import React, { useEffect } from 'react';
import { useToast } from '../context';
import { registerToastHandler } from '../utils';

export const ToastInitializer: React.FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    registerToastHandler(showToast);
    return () => registerToastHandler(null);
  }, [showToast]);

  return null;
};
